/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Vehicle model module.
 * @module model/Vehicle
 * @version 0.0.2
 */
class Vehicle {
    /**
     * Constructs a new <code>Vehicle</code>.
     * @alias module:model/Vehicle
     * @param vehicleId {String} A unique identifier for this vehicle, represented as a UUID.
     * @param vehicleTypeId {String} The vehicleTypeId for this vehicle. This vehicleTypeId must exist in the VehicleTypes passed in ProblemData for this problem.
     * @param startLocationId {String} The locationId of the depot for this vehicle type. This locationId must exist in the Locations passed in ProblemData for this problem.
     */
    constructor(vehicleId, vehicleTypeId, startLocationId) { 
        
        Vehicle.initialize(this, vehicleId, vehicleTypeId, startLocationId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, vehicleId, vehicleTypeId, startLocationId) { 
        obj['vehicleId'] = vehicleId;
        obj['vehicleTypeId'] = vehicleTypeId;
        obj['fixedCost'] = 0;
        obj['minStartTimeInt'] = 0;
        obj['minStartDayInt'] = 0;
        obj['maxEndDayInt'] = 0;
        obj['startLocationId'] = startLocationId;
        obj['color'] = '#FFFFFF';
    }

    /**
     * Constructs a <code>Vehicle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Vehicle} obj Optional instance to populate.
     * @return {module:model/Vehicle} The populated <code>Vehicle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Vehicle();

            if (data.hasOwnProperty('vehicleId')) {
                obj['vehicleId'] = ApiClient.convertToType(data['vehicleId'], 'String');
            }
            if (data.hasOwnProperty('vehicleName')) {
                obj['vehicleName'] = ApiClient.convertToType(data['vehicleName'], 'String');
            }
            if (data.hasOwnProperty('vehicleTypeId')) {
                obj['vehicleTypeId'] = ApiClient.convertToType(data['vehicleTypeId'], 'String');
            }
            if (data.hasOwnProperty('fixedCost')) {
                obj['fixedCost'] = ApiClient.convertToType(data['fixedCost'], 'Number');
            }
            if (data.hasOwnProperty('minStartTimeInt')) {
                obj['minStartTimeInt'] = ApiClient.convertToType(data['minStartTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('minStartTimeStr')) {
                obj['minStartTimeStr'] = ApiClient.convertToType(data['minStartTimeStr'], 'String');
            }
            if (data.hasOwnProperty('minStartDayInt')) {
                obj['minStartDayInt'] = ApiClient.convertToType(data['minStartDayInt'], 'Number');
            }
            if (data.hasOwnProperty('maxEndTimeInt')) {
                obj['maxEndTimeInt'] = ApiClient.convertToType(data['maxEndTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('maxEndTimeStr')) {
                obj['maxEndTimeStr'] = ApiClient.convertToType(data['maxEndTimeStr'], 'String');
            }
            if (data.hasOwnProperty('maxEndDayInt')) {
                obj['maxEndDayInt'] = ApiClient.convertToType(data['maxEndDayInt'], 'Number');
            }
            if (data.hasOwnProperty('startLocationId')) {
                obj['startLocationId'] = ApiClient.convertToType(data['startLocationId'], 'String');
            }
            if (data.hasOwnProperty('endLocationId')) {
                obj['endLocationId'] = ApiClient.convertToType(data['endLocationId'], 'String');
            }
            if (data.hasOwnProperty('color')) {
                obj['color'] = ApiClient.convertToType(data['color'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Vehicle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Vehicle</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of Vehicle.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['vehicleId'] && !(typeof data['vehicleId'] === 'string' || data['vehicleId'] instanceof String)) {
            throw new Error("Expected the field `vehicleId` to be a primitive type in the JSON string but got " + data['vehicleId']);
        }
        // ensure the json data is a string
        if (data['vehicleName'] && !(typeof data['vehicleName'] === 'string' || data['vehicleName'] instanceof String)) {
            throw new Error("Expected the field `vehicleName` to be a primitive type in the JSON string but got " + data['vehicleName']);
        }
        // ensure the json data is a string
        if (data['vehicleTypeId'] && !(typeof data['vehicleTypeId'] === 'string' || data['vehicleTypeId'] instanceof String)) {
            throw new Error("Expected the field `vehicleTypeId` to be a primitive type in the JSON string but got " + data['vehicleTypeId']);
        }
        // ensure the json data is a string
        if (data['minStartTimeStr'] && !(typeof data['minStartTimeStr'] === 'string' || data['minStartTimeStr'] instanceof String)) {
            throw new Error("Expected the field `minStartTimeStr` to be a primitive type in the JSON string but got " + data['minStartTimeStr']);
        }
        // ensure the json data is a string
        if (data['maxEndTimeStr'] && !(typeof data['maxEndTimeStr'] === 'string' || data['maxEndTimeStr'] instanceof String)) {
            throw new Error("Expected the field `maxEndTimeStr` to be a primitive type in the JSON string but got " + data['maxEndTimeStr']);
        }
        // ensure the json data is a string
        if (data['startLocationId'] && !(typeof data['startLocationId'] === 'string' || data['startLocationId'] instanceof String)) {
            throw new Error("Expected the field `startLocationId` to be a primitive type in the JSON string but got " + data['startLocationId']);
        }
        // ensure the json data is a string
        if (data['endLocationId'] && !(typeof data['endLocationId'] === 'string' || data['endLocationId'] instanceof String)) {
            throw new Error("Expected the field `endLocationId` to be a primitive type in the JSON string but got " + data['endLocationId']);
        }
        // ensure the json data is a string
        if (data['color'] && !(typeof data['color'] === 'string' || data['color'] instanceof String)) {
            throw new Error("Expected the field `color` to be a primitive type in the JSON string but got " + data['color']);
        }

        return true;
    }


}

Vehicle.RequiredProperties = ["vehicleId", "vehicleTypeId", "startLocationId"];

/**
 * A unique identifier for this vehicle, represented as a UUID.
 * @member {String} vehicleId
 */
Vehicle.prototype['vehicleId'] = undefined;

/**
 * A name for this vehicle (optional).
 * @member {String} vehicleName
 */
Vehicle.prototype['vehicleName'] = undefined;

/**
 * The vehicleTypeId for this vehicle. This vehicleTypeId must exist in the VehicleTypes passed in ProblemData for this problem.
 * @member {String} vehicleTypeId
 */
Vehicle.prototype['vehicleTypeId'] = undefined;

/**
 * The fixed cost for using this vehicle.
 * @member {Number} fixedCost
 * @default 0
 */
Vehicle.prototype['fixedCost'] = 0;

/**
 * An integer value representing the earliest time this vehicle can depart from its depot to begin its route(s) (time t=0 is the earliest start time). Leave empty if there are no restrictions on when the vehicle can start.
 * @member {Number} minStartTimeInt
 * @default 0
 */
Vehicle.prototype['minStartTimeInt'] = 0;

/**
 * A string value representing the earliest time this vehicle can depart from its depot to begin its route(s). Leave empty if there are no restrictions on when the vehicle can start. The time format should match the timeFormat field in ProblemData.timeSettings.
 * @member {String} minStartTimeStr
 */
Vehicle.prototype['minStartTimeStr'] = undefined;

/**
 * An integer value representing the earliest day this vehicle can depart from its depot to begin its route(s). Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on when the vehicle can start.
 * @member {Number} minStartDayInt
 * @default 0
 */
Vehicle.prototype['minStartDayInt'] = 0;

/**
 * An integer value representing the latest time this vehicle must return to its depot after completing its route(s) (time t=0 is the earliest start time). Leave empty if there are no restrictions on when the vehicle must finish.
 * @member {Number} maxEndTimeInt
 */
Vehicle.prototype['maxEndTimeInt'] = undefined;

/**
 * A string value representing the latest time this vehicle must return to its depot after completing its route(s). Leave empty if there are no restrictions on when the vehicle must finish. The time format should match the timeFormat field in ProblemData.timeSettings.
 * @member {String} maxEndTimeStr
 */
Vehicle.prototype['maxEndTimeStr'] = undefined;

/**
 * An integer value representing the latest day this vehicle must return to its depot after completing its route(s). Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on when the vehicle must finish.
 * @member {Number} maxEndDayInt
 * @default 0
 */
Vehicle.prototype['maxEndDayInt'] = 0;

/**
 * The locationId of the depot for this vehicle type. This locationId must exist in the Locations passed in ProblemData for this problem.
 * @member {String} startLocationId
 */
Vehicle.prototype['startLocationId'] = undefined;

/**
 * The locationId of the depot for this vehicle type. If null, then the startLocationId will be used as the end location. This locationId must exist in the Locations passed in ProblemData for this problem.
 * @member {String} endLocationId
 */
Vehicle.prototype['endLocationId'] = undefined;

/**
 * The color to use for this vehicle in the output. This can be any valid hex color code.
 * @member {String} color
 * @default '#FFFFFF'
 */
Vehicle.prototype['color'] = '#FFFFFF';






export default Vehicle;

